/* @flow */
import React, { Component } from 'react';
import {
  graphql,
  createPaginationContainer,
  type RelayPaginationProp,
} from 'react-relay';
import { List } from 'material-ui/List';
import RaisedButton from 'material-ui/RaisedButton';
import type { RelayProp } from 'react-relay';
import type { ContextRouter } from 'react-router';

import StudentJobSessionHistory from './StudentJobSessionHistory';
import type { StudentHistory_student } from './__generated__/StudentHistory_student.graphql';

type Props = {
  relay: RelayProp,
  student: StudentHistory_student,
} & ContextRouter &
  RelayPaginationProp;

type State = {
  error: ?Error,
};

class StudentHistory extends Component<Props, State> {
  state = {
    error: null,
  };

  handleLoadMore = () => {
    if (!this.props.relay.hasMore() || this.props.relay.isLoading()) {
      return;
    }

    this.props.relay.loadMore(
      10, // Fetch the next 10 feed items
      error => {
        this.setState({ error });
      }
    );
  };

  render() {
    const { student: { history } } = this.props;
    const { error } = this.state;

    return (
      history && (
        <div>
          {error && error.message}
          <List>
            {history.edges.map(
              edge =>
                edge &&
                edge.node && (
                  <StudentJobSessionHistory
                    key={edge.node.id}
                    session={edge.node}
                  />
                )
            )}
          </List>

          <RaisedButton
            label="Load More"
            disabled={!history.pageInfo.hasNextPage}
            fullWidth
            secondary
            onClick={this.handleLoadMore}
          />
        </div>
      )
    );
  }
}

export default createPaginationContainer(
  StudentHistory,
  {
    student: graphql`
      fragment StudentHistory_student on Student {
        history: jobSessions(
          first: $historyCount
          after: $historyCursor
          status: [Completed]
          orderBy: [{ field: startDate, direction: desc }]
        ) @connection(key: "StudentHistory_history") {
          edges {
            node {
              id
              ...StudentJobSessionHistory_session
            }
          }
          pageInfo {
            hasNextPage
          }
        }
      }
    `,
  },
  {
    direction: 'forward',
    getConnectionFromProps(props) {
      return props.student && props.student.history;
    },
    // This is also the default implementation of `getFragmentVariables` if it isn't provided.
    getFragmentVariables(prevVars, totalCount) {
      return {
        ...prevVars,
        count: totalCount,
      };
    },
    getVariables(props, { count, cursor } /* , fragmentVariables */) {
      return {
        count,
        cursor,
        nodeId: props.nodeId,
      };
    },
    query: graphql`
      query StudentHistoryPaginationAdminQuery(
        $historyCursor: String
        $historyCount: Int
        $nodeId: ID!
      ) {
        student: node(id: $nodeId) {
          ...StudentHistory_student
        }
      }
    `,
  }
);



// WEBPACK FOOTER //
// ./src/modules/admin/student/components/StudentHistory.js